export default __webpack_public_path__ + "static/media/photo--lg--122.37048505.jpg";